import { observer } from 'mobx-react-lite';

import { useCalendarPresenter } from 'APP/main/Calendar/Calendar.presenter';
import { Content } from 'APP/main/Calendar/Content/Content';
import { Loading } from 'APP/main/Calendar/Loading/Loading';

import styles from './CompactViewCalendar.styles.m.css';

export const CompactViewCalendar = observer(() => {
  const presenter = useCalendarPresenter();

  if (presenter.isLoading) {
    return <Loading />;
  }

  return (
    <div className={styles.container}>
      <Content isCompact />
    </div>
  );
});
